var Pixel = Pixel || {};

function parseCategory(category)
{
    var items = {};
    $.each(category.split(' > '), function(i, cat){
        var itemName = 'item_category'
        if (i > 0) itemName += (i+1);
        items[itemName] = cat.trim();
    });
    return items;
}

Pixel.GTM = (function (PixelBase) {
    var GTM = PixelBase.extend({
        initialize: function (opts) {

        },

        pageView: function () {
            window.dataLayer = window.dataLayer || [];

            if (location.href.toLocaleLowerCase().indexOf('checkout.aspx') >= 0) {
                window.dataLayer.push({
                    "pageType": "Checkout"
                });
            }

            if (window.app && app.cookie && app.cookie.get) {
                var isAuthorized = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');

                window.dataLayer.push({
                    "userStatus": isAuthorized ? "logged in" : "logged out"
                });
            }

            dataLayer.push({ "event": "pageReady", "pagePath": location.href });
        },

        viewCheckout: function (data) {
            if (!window.dataLayer || !dataLayer.push) {
                return;
            }

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

            var items = $.map(data.Items, function(item){
                return _.extend({
                    item_id: item.ItemID, //Sku of the product
                    item_name: item.Item, // Name of the product
                    affiliation: item.SaleName, // Online Affiliation name
                    currency: data.Currency, // Currency
                    discount: item.Discount, // Any product level discounts
                    item_brand: item.BrandName, // The brand of the product
                    price: item.Price, // The actual price of the product
                    cost_price: item.CTCostPrice,
                    quantity: item.Qty,
                    hashedID: item.HashedId,
                    //index: 0, the index of the product in terms of what position in the list.
                }, parseCategory(item.Category));     
            });

            dataLayer.push({
                event: "begin_checkout_ga4",
                ecommerce: {
                    items: items
                }
            });
        },

        paymentInfo : function(data) {
            if (!window.dataLayer || !dataLayer.push) {
                return;
            }

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

            var items = $.map(data.Items, function(item){
                return _.extend({
                    item_id: item.ItemID, //Sku of the product
                    item_name: item.Item, // Name of the product
                    affiliation: item.SaleName, // Online Affiliation name
                    currency: data.Currency, // Currency
                    discount: item.Discount, // Any product level discounts
                    item_brand: item.BrandName, // The brand of the product
                    price: item.Price, // The actual price of the product
                    cost_price: item.CTCostPrice,
                    quantity: item.Qty,
                    hashedID: item.HashedId,
                    //index: 0, the index of the product in terms of what position in the list.
                }, parseCategory(item.Category));     
            });

            dataLayer.push({
                event: "add_payment_info_ga4",
                ecommerce: {
                    currency: data.Currency,
                    value: data.Total,
                    payment_type: data.PaymentType,
                    items: items
                }
            });
        },

        addShippingInfo : function(data) {
            if (!window.dataLayer || !dataLayer.push) {
                return;
            }

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

            var items = $.map(data.Items, function(item){
                return _.extend({
                    item_id: item.ItemID, //Sku of the product
                    item_name: item.Item, // Name of the product
                    affiliation: item.SaleName, // Online Affiliation name
                    currency: data.Currency, // Currency
                    discount: item.Discount, // Any product level discounts
                    item_brand: item.BrandName, // The brand of the product
                    price: item.Price, // The actual price of the product
                    cost_price: item.CTCostPrice,
                    quantity: item.Qty,
                    hashedID: item.HashedId,
                    //index: 0, the index of the product in terms of what position in the list.
                }, parseCategory(item.Category));     
            });

            dataLayer.push({
                event: "add_shipping_info_ga4",
                ecommerce: {
                    currency: data.Currency,
                    value: data.Total,
                    shipping_tier: "Ground",
                    items: items
                }
            });
        },

        purchaseSuccess: function (opts) {
            opts = opts || {};
            var data = opts.OrderInfoResult;
            var discounts = opts.discounts;
            var currency = opts.currencyIso;

            if (!window.dataLayer || !dataLayer.push) {
                return;
            }

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

            var products = [];
            var items = [];

            if (data.Items) {
                $.each(data.Items, function (i, v) {
                    products.push({
                        'name': this.ProductName, // Name is required.
                        'id': this.Sku, // The Sku of the Product
                        'price': this.Price, //
                        'cost_price': this.CTCostPrice,
                        'variant': this.SizeName, // Mainly relate to size
                        'quantity': this.Quantity,	// Quantity
                        'hashedID': this.HashedId,

                        //'brand': 'Tommy Hilfiger', // Brand of the product
                        //'category': 'Accessories', // The category of the product. I note there can be more than one. If there is a ‘primary’ use that and we will use a ‘sub category’ for anything else.
                        //'list': 'PLP', // The name of the list or page that the product was shown in ie. Search. Homepage, PDP etc.
                        //'position': 1,
                        //'subCategory': 'Handbags',
                        //'breadcrumbs': 'Shop : Women : Accessories : Handbags', //Colon separated
                        //'color': 'color’ // otherwise null or undefined
                        //'sale': 'true | false’ // otherwise null or undefined
                    });

                    var item = {
                        item_id: this.Sku, //Sku of the product
                        item_name: this.ProductName, // Name of the product
                        affiliation: data.SaleName, // Online Affiliation name
                        currency: currency, // Currency
                        discount: (discounts && discounts.length > 0 && discounts[i]) || 0, // Any product level discounts
                        // index: 0, // the index of the product in terms of what position in the list.
                        item_brand: this.BrandName, // The brand of the product
                        price: this.Price, // The actual price of the product
                        cost_price: this.CTCostPrice,
                        quantity: this.Quantity,
                        hashedID: this.HashedId,
                    }

                    _.extend(item, parseCategory(this.Category));

                    items.push(item);
                });
            }

            var isFirstOrder = false;
            if (data.IsFirstOrder && (data.IsFirstOrder === true || data.IsFirstOrder === false)) {
                isFirstOrder = data.IsFirstOrder;
            }

            dataLayer.push({
                event: "purchase",
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: data.InvoiceNo, // Transaction ID. Required for purchases and refunds.
                            affiliation: data.SaleName,
                            revenue: data.Total, // Total transaction value (incl. tax and shipping)
                            tax: data.Tax,
                            shipping: data.Shipping,
                            isFirstOrder: isFirstOrder,
                            coupon: data.UsedCouponCode
                        },
                        products: products,
                    },
                },
            });

            dataLayer.push({ ecommerce: null });// Clear the previous ecommerce object.
            dataLayer.push({
                event: "purchase_ga4",
                ecommerce: {
                    transaction_id: 'T_' + data.InvoiceNo,
                    affiliation: data.SaleName,
                    value: data.Total,
                    tax: data.Tax,
                    shipping: data.Shipping,
                    currency: currency,
                    items: items,
                    coupon: data.UsedCouponCode
                }
            });
        },

        removeFromCart: function(data){

            if (!window.dataLayer || !dataLayer.push) {
                return;
            }
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

            var item = {
                item_id: data.ItemID, //Sku of the product
                item_name: data.Item, // Name of the product
                affiliation: data.SaleName, // Online Affiliation name
                currency: data.Currency, // Currency
                discount: data.Discount, // Any product level discounts
                item_brand: data.BrandName, // The brand of the product
                price: data.Price, // The actual price of the product
                cost_price: data.CTCostPrice,
                quantity: data.Qty,
                hashedID: data.HashedId,
                //index: 0, the index of the product in terms of what position in the list.
            };

            _.extend(item, parseCategory(data.Category));

            dataLayer.push({
                event: "remove_from_cart_ga4",
                ecommerce: {
                    items: [item]
                }
            });
        }
    });

    return GTM;
})(Pixel.PixelBase);

!function (Pixel) {
    new Pixel.GTM();
}(Pixel);
